import React from 'react';
import '../../styles/Home.css';

/**
 * Composant de fond animé pour la page d'accueil
 * Affiche des orbes de gradient animés et une grille en overlay
 *
 * @component
 * @returns {JSX.Element} Le composant de fond
 */
const HomeBackground = () => (
  <div className="home-background">
    <div className="gradient-orb gradient-orb-1"></div>
    <div className="gradient-orb gradient-orb-2"></div>
    <div className="gradient-orb gradient-orb-3"></div>
    <div className="grid-overlay"></div>
  </div>
);

export default HomeBackground;
